import React from "react";

export const PayPalComponent = () => {
  return <div>PayPal Button</div>;
};
